import { useQuery } from '@tanstack/react-query';
import { ajaxFetch } from '~/helpers/api';
import { routes } from '~/helpers/routes';
import type { Entity, Evaluation } from '~/entities/types';

type EvaluationRunDataResponse = {
  agent_email: string;
  bearer_token: string;
  applications: Record<string, unknown>;
  document_types: unknown[];
};

type EntityEvaluationDataResponse = {
  entity: Entity;
  event: Evaluation;
};

export type RerunEvaluationPageData = {
  entity: Entity;
  evaluation: Evaluation;
  applications: Record<string, unknown>;
  agentEmail: string;
  bearerToken: string;
  documentTypes: unknown[];
};

export const useRerunEvaluationData = ({
  entityToken,
  evaluationToken,
}: {
  entityToken?: string;
  evaluationToken?: string;
}) => useQuery({
  queryKey: ['rerunEvaluation.data', entityToken, evaluationToken],
  enabled: Boolean(entityToken && evaluationToken),
  queryFn: async (): Promise<RerunEvaluationPageData> => {
    const [evaluationData, runData] = await Promise.all([
      ajaxFetch(
        routes.entities.evaluation.detail({
          entityToken: entityToken!,
          evaluationToken: evaluationToken!,
        }),
      ) as Promise<EntityEvaluationDataResponse>,
      ajaxFetch(routes.evaluations.runData, { silent: true }) as Promise<EvaluationRunDataResponse>,
    ]);

    return {
      entity: evaluationData.entity,
      evaluation: evaluationData.event,
      applications: runData.applications,
      agentEmail: runData.agent_email,
      bearerToken: runData.bearer_token,
      documentTypes: runData.document_types,
    };
  },
});
